import { Component, OnInit, ViewChild, Input, Output, TemplateRef, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styles: [],
    standalone: false
})
export class ConfirmationComponent implements OnInit {
  @Input() public title: string;
  @Input() public prompt: string;
  @Input() public acceptButtonCaption: string = "OK";
  @Input() public cancelButtonCaption: string = "Cancel";
  @Output() public result: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("confirmDialog") confirmDialog: TemplateRef<any> = {} as TemplateRef<any>;

  private data: string;

  public modalRef: NgbModalRef;

  constructor(private readonly modalService: NgbModal) { }

  public ngOnInit(): void {
  }

  public open(data: string): void {
    this.data = data;
    this.modalRef = this.modalService.open(this.confirmDialog);
  }

  public onAccept(): void {
    this.modalRef.close();
    this.result.emit(this.data);
  }
}
